import { CoinGeckoRegistryItem } from '../types';
import {
  COINGECKO_LAZY_TTL_MS,
  COINGECKO_MARKETS_TTL_MS,
  COINGECKO_SEARCH_TTL_MS,
} from './coingecko';

export const COINGECKO_PAGE_TABS: CoinGeckoRegistryItem[] = [
  {
    id: 'markets',
    label: 'Markets',
    resourceKey: 'markets',
    fetchMode: 'poll',
    ttlMs: COINGECKO_MARKETS_TTL_MS,
    status: 'active',
    pageTab: 'markets',
    description: 'Central tracked markets shared by the dashboard, market view, and watchlist.',
  },
  {
    id: 'trending',
    label: 'Trending',
    resourceKey: 'trending',
    fetchMode: 'lazy',
    ttlMs: COINGECKO_LAZY_TTL_MS,
    status: 'active',
    pageTab: 'trending',
    description: 'Lazy-loaded trending coins from CoinGecko with market cards hydrated on demand.',
  },
  {
    id: 'global',
    label: 'Global',
    resourceKey: 'global',
    fetchMode: 'lazy',
    ttlMs: COINGECKO_LAZY_TTL_MS,
    status: 'active',
    pageTab: 'global',
    description: 'Global market cap, volume, and dominance metrics fetched only when needed.',
  },
  {
    id: 'search',
    label: 'Search',
    resourceKey: 'search',
    fetchMode: 'manual',
    ttlMs: COINGECKO_SEARCH_TTL_MS,
    status: 'active',
    pageTab: 'search',
    description: 'Manual coin search with shared query caching so repeated searches reuse data.',
  },
  {
    id: 'categories',
    label: 'Categories',
    resourceKey: 'categories',
    fetchMode: 'scaffold',
    ttlMs: COINGECKO_LAZY_TTL_MS,
    status: 'scaffold',
    pageTab: 'categories',
    description: 'Category catalog slot prepared for future CoinGecko category endpoints.',
  },
  {
    id: 'exchanges',
    label: 'Exchanges',
    resourceKey: 'exchanges',
    fetchMode: 'scaffold',
    ttlMs: COINGECKO_LAZY_TTL_MS,
    status: 'scaffold',
    pageTab: 'exchanges',
    description: 'Exchange directory placeholder with registry wiring ready for activation.',
  },
  {
    id: 'derivatives',
    label: 'Derivatives',
    resourceKey: 'derivatives',
    fetchMode: 'scaffold',
    ttlMs: COINGECKO_LAZY_TTL_MS,
    status: 'scaffold',
    pageTab: 'derivatives',
    description: 'Derivatives analytics scaffold ready for a future lazy resource fetch.',
  },
  {
    id: 'nft',
    label: 'NFT',
    resourceKey: 'nft',
    fetchMode: 'scaffold',
    ttlMs: COINGECKO_LAZY_TTL_MS,
    status: 'scaffold',
    pageTab: 'nft',
    description: 'NFT-focused CoinGecko surface reserved for later implementation.',
  },
  {
    id: 'onchain-dex',
    label: 'Onchain/DEX',
    resourceKey: 'onchain-dex',
    fetchMode: 'scaffold',
    ttlMs: COINGECKO_LAZY_TTL_MS,
    status: 'scaffold',
    pageTab: 'onchain-dex',
    description: 'Onchain and DEX data slot prepared for future extension work.',
  },
];

export const DEFAULT_COINGECKO_TAB = COINGECKO_PAGE_TABS[0].id;
